type EmptySlotProps = {
    isPaid?: boolean;
    isPrivate?: boolean;
    onInvite?: () => void;
};

const EmptySlot = ({ isPaid, isPrivate, onInvite }: EmptySlotProps) => (
    <div className="flex flex-col items-center gap-1.5 md:gap-2 viewport-landscape:gap-[clamp(0.25rem,1vh,0.75rem)]">
        <div
            className={`w-14 h-14 xs:w-16 xs:h-16 md:w-24 md:h-24 viewport-landscape:w-[clamp(4.5rem,16vh,7rem)] viewport-landscape:h-[clamp(4.5rem,16vh,7rem)] rounded-full border-[2px] border-dashed border-white/15 flex items-center justify-center bg-white/5 ${isPrivate ? "cursor-pointer hover:bg-white/10 transition-colors active:scale-95" : ""}`}
            onClick={isPrivate ? onInvite : undefined}
        >
            <span className="text-white/15 text-2xl md:text-4xl font-bold">{isPrivate ? "+" : "?"}</span>
        </div>
        <div className="h-[18px]"></div>
        {isPaid && <div className="h-4"></div>}
    </div>
);

export default EmptySlot;
